import moment from 'moment'

import type { DaysTree } from 'modules/timeoff/lib/getDateRangeFromTree'
import { leaveValidFinishOn } from 'modules/timeoff/lib/leaveEmployees'
import rangeByDay from 'modules/timeoff/lib/rangeByDay'
import type LeaveModel from 'modules/timeoff/store/models/Leave'

import insertToTree from './insertToTree'

const getRange = (leave: LeaveModel) => {
  return rangeByDay(moment(leave.attributes.start_on), leaveValidFinishOn(leave))
}

class LeavesToDateTree {
  leaves: LeaveModel[]
  memo: DaysTree

  constructor(leaves: LeaveModel[]) {
    this.leaves = leaves
    this.memo = {}
  }

  /**
   * Spreads the range of days for a given leave
   * in a tree shape so it can be searched efficiently.
   *
   * The tree has the shape of:
   *
   *  {
   *    year: {
   *      month: [{date: number, type: string}]
   *    }
   *  }
   */
  munch() {
    this.leaves.forEach((leave: LeaveModel) => {
      if (leave.isRejected()) return

      const focus = false
      const type = ''
      getRange(leave).forEach((day) => {
        if (focus) insertToTree(this.memo, 'focus')(day)

        insertToTree(this.memo, type)(day)
      })
    })

    return this.memo
  }
}

export default LeavesToDateTree
